import {
  DialogRoot,
  DialogPortal,
  DialogBackdrop,
  DialogPopup,
  DialogHeader,
  DialogTitle,
  DialogContent,
  DialogCloseButton,
} from '../ui/dialog';
import { EarningForm, type EarningFormData } from '../forms/earning-form';
import type { PortfolioInput } from '../../lib/investments';
import type { Earning, InvestmentAsset } from '../../types';

export interface EarningDialogProps {
  open: boolean;
  editing: Earning | null;
  assets: InvestmentAsset[];
  portfolio: PortfolioInput;
  defaultAssetId?: string;
  onSubmit: (data: EarningFormData) => void;
  onClose: () => void;
}

export function EarningDialog({
  open,
  editing,
  assets,
  portfolio,
  defaultAssetId,
  onSubmit,
  onClose,
}: EarningDialogProps) {
  return (
    <DialogRoot
      open={open}
      onOpenChange={(isOpen) => {
        if (!isOpen) onClose();
      }}
    >
      <DialogPortal>
        <DialogBackdrop className="z-40" />
        <DialogPopup className="z-41 max-h-[90vh] overflow-y-auto">
          <DialogHeader>
            <DialogTitle>{editing ? 'Editar provento' : 'Novo provento'}</DialogTitle>
            <DialogCloseButton />
          </DialogHeader>
          <DialogContent>
            <EarningForm
              onSubmit={onSubmit}
              onClose={onClose}
              initialData={editing}
              assets={assets}
              portfolio={portfolio}
              defaultAssetId={defaultAssetId}
            />
          </DialogContent>
        </DialogPopup>
      </DialogPortal>
    </DialogRoot>
  );
}
